import { Group, Skeleton } from "@mantine/core";

export const CustomFieldLoader = () => (
  <Group spacing="lg">
    <Skeleton height={30} width={120} radius="xl" />
    <Skeleton height={30} width={120} radius="xl" />
    <Skeleton height={30} width={120} radius="xl" />
  </Group>
);
